import { useForm } from "react-hook-form";
import { useMutation } from "urql";
import { format } from "date-fns";
import { BillingTier } from "../../../../../__generated__/gql/graphql";
import { billingTierLabel } from "../../../../../util/billing";
import { graphql } from "../../../../../__generated__/gql";
import useUser from "../../../../../providers/UserProvider/useUser";
import Modal from "../../../../../ui/Modal/Modal";
import ConfirmationModal from "../../../../../ui/Modal/ConfirmationModal";

const DowngradePlanMutation = graphql(/* GraphQL */ `
  mutation downgradePlan($billingTier: BillingTier!) {
    downgradePlan(billingTier: $billingTier) {
      billingTier
    }
  }
`);

function DowngradePlanModal({
  isOpen,
  onClose,
  onSubmit: onSubmitProp,
  billingTier,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  billingTier: BillingTier;
}) {
  const { billingInfo } = useUser();
  const [, downgradePlan] = useMutation(DowngradePlanMutation);
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();

  const onSubmit = async () => {
    await downgradePlan({ billingTier });
    onClose();
    onSubmitProp();
  };

  if (!billingInfo.currentPeriodEnd) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Cancel plan?">
      <form onSubmit={handleSubmit(onSubmit)}>
        <p style={{ marginBottom: "8px" }}>
          Your plan will be downgraded to <b>{billingTierLabel[billingTier]}</b>{" "}
          at the end of your current billing cycle on{" "}
          <b>{format(new Date(billingInfo.currentPeriodEnd), "PP")}</b>
        </p>
        <ConfirmationModal onClose={onClose} loading={isSubmitting} />
      </form>
    </Modal>
  );
}

export default DowngradePlanModal;
